import { Fragment, PropsWithChildren, ReactNode } from "react";
import { Popover, Transition } from "@headlessui/react";
export const openDetailPageCalendar = (id?: string) => {
  window?.document?.getElementById(id || "calendarTrigger")?.click();
};
export const closeDetailPageCalendar = (id?: string) => {
  window?.document?.getElementById(id || "calendarCloseTrigger")?.click();
};
interface CalendarPopOverProps {
  children?: ReactNode;
  onOpen: () => void;
  onClose: () => void;
  isDisabled: boolean;
  usedFromContactHost?: boolean;
}
const CalendarPopOver = ({
  children,
  onOpen,
  onClose,
  isDisabled,
  usedFromContactHost
}: PropsWithChildren<CalendarPopOverProps>) => {
  return <Popover className='relative h-0 ' data-sentry-element="Popover" data-sentry-component="CalendarPopOver" data-sentry-source-file="CalendarPopOver.tsx">
      {({
      close,
      open
    }) => <>
          <Popover.Button type='button' aria-label='Calendar Date Selection' id={usedFromContactHost ? "contactHostCalendarTrigger" : "calendarTrigger"} className='absolute bottom-0 h-5 max-h-5 w-1/2 opacity-0' onClick={() => {
        if (!isDisabled) {
          if (open) {
            onClose();
          } else {
            onOpen();
          }
        }
      }}></Popover.Button>
          <Transition as={Fragment} enter='transition ease-out duration-200' enterFrom='opacity-0 translate-y-1' enterTo='opacity-100 translate-y-0' leave='transition ease-in duration-150' leaveFrom='opacity-100 translate-y-0' leaveTo='opacity-0 translate-y-1'>
            <Popover.Panel className='absolute -right-3 left-auto top-[6px] z-[1] w-[900px] max-w-[90vw] rounded-[1.25rem] border border-[#e2e5e5] bg-offWhite px-3 pb-0 pt-2 shadow-[0px_3px_6px_#61797c29] min-[1080px]:right-0'>
              {children}
              <button onClick={close} id='calendarCloseTrigger' className='h-0 max-h-0 w-0 opacity-0'></button>
            </Popover.Panel>
          </Transition>
        </>}
    </Popover>;
};
export default CalendarPopOver;